import { render } from "./ecom-payment-method.vue?vue&type=template&id=6fbb054e"
import script from "./ecom-payment-method.vue?vue&type=script&lang=js"
export * from "./ecom-payment-method.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__